import * as ApiBase from '@/api/apiBase';
import { Job as JobDetail } from '@/models/jobDetail/job';
import { Job as JobSummary } from '@/models/jobSummary/job';
import { JobUserAssignment } from '@/models/jobStatus/jobUserAssignment';
import { JobNotes } from '@/models/jobNotes/jobNotes';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { JobServiceFormRequest } from '@/models/jobServiceForm/jobServiceFormRequest';
import Nullable from '@/types/nullable';
import { JobNotification } from '@/models/jobNotification/jobNotification';
import { JobSafetyDoc } from '@/models/jobSafetyDocs/jobSafetyDoc';
import { RiskMatrixOptions } from '@/models/jobServiceForm/riskMatrixOptions';
import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';

export async function getJobs(year: number): Promise<JobSummary[]> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=year&year=' + year);

  return result.data;
}

export async function getJob(id: string): Promise<JobDetail> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=id&id=' + id);

  return result.data;
}

export async function getStatusHistory(id: string): Promise<JobUserAssignment> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=status&id=' + id);

  return result.data;
}

export async function removeStatusHistory(jobUserID: number): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.delete('/jobs?action=status&id=' + jobUserID);

  return result.data;
}

export async function createOrUpdateStatusHistory(jobUserAssignmentID: Nullable<number>, jobUserAssignmentStatusID: Nullable<number>, statusAt: string, statusID: number, comment: string): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.post('/jobs?action=status', {
    jobUserAssignmentID: jobUserAssignmentID,
    jobUserAssignmentStatusID: jobUserAssignmentStatusID,
    statusAt: statusAt,
    statusID: statusID,
    comment: comment
  });

  return result.data;
}

export async function getNotes(jobID: string): Promise<[JobNotes]> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=notes&id=' + jobID);

  return result.data;
}

export async function getJobNotificationAttachmentUploadURL(jobID: string, jobNotificationID: string, jobNotificationAttachmentID: string, contentType: string, fileName: string): Promise<string> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get(`/jobs?action=notificationAttachmentUploadURL&id=${jobID}&jobNotificationID=${jobNotificationID}&jobNotificationAttachmentID=${jobNotificationAttachmentID}&contentType=${contentType}&fileName=${fileName}`);

  return result.data;
}

export async function createOrUpdateNotes(jobID: string, notes: string): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.post('/jobs?action=notes', {
    jobID: jobID,
    notes: notes
  });

  return result.data;
}

export async function getServiceForm(jobID: string): Promise<JobServiceForm> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=serviceform&id=' + jobID);

  return result.data;
}

export async function createOrUpdateServiceForm(serviceFormRequest: JobServiceFormRequest): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.post('/jobs?action=serviceform', serviceFormRequest);

  return result.data;
}

export async function sendFailedTestNotification(jobNotification: JobNotification): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.post('/jobs?action=sendFailedTestNotification', jobNotification);

  return result.data;
}

export async function emailServiceForm(jobID: string, email: string): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.post(`/jobs?action=emailserviceform&id=${jobID}&email=${email}`);

  return result.data;
}

export async function getTake5Form(jobID: string): Promise<any> {

  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=take5&id=' + jobID);

  return result.data;
}

export async function getSafetyDocs(jobID: string): Promise<JobSafetyDoc[]> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=safetydocs&id=' + jobID);

  return result.data;
}

export async function getSafetyDoc(safetyDocID: number): Promise<JobSafetyDoc> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=safetydoc&id=' + safetyDocID);

  return result.data;
}


export async function getRiskMatrixOptions(): Promise<RiskMatrixOptions> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.get('/jobs?action=riskMatrixOptions');

  return result.data;
}

export async function createOrUpdateTake5Form(take5: JobTake5Check) {
  
  const http = await ApiBase.createHttpRequest();

  const result = await http.post('/jobs?action=take5', take5);

  return result.data;
}
export async function emailTake5Form(formID: string, email: string): Promise<boolean> {
  const http = await ApiBase.createHttpRequest();

  const result = await http.post(`/jobs?action=emailtake5form&id=${formID}&email=${email}`);

  return result.data;
}
